<button class="close text-right " [mat-dialog-close]="true" mat-button (click)="clickClose()">
   <i class="fa-solid fa-xmark fa-2xl"></i></button>
<h1 mat-dialog-title>Galleria</h1>
<div mat-dialog-content>
   <img class="center" [src]="myFullresImage" alt="" height="400">
   <dx-gallery
      #gallery
      id="gallery"
      [dataSource]="images"
      [width]="'100%'"
      [height]="'auto'"
      [slideshowDelay]="50000"
      [loop]="true"
      [showNavButtons]="true"
      [showIndicator]="true"
      [stretchImages]="false"
   ></dx-gallery>
</div>
